import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31fa544d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "command-box ws_pb10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请选择配置命令", -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "ws_drawer_footer" }

import { ref, watch, nextTick, computed } from 'vue'
import { PAGE_SIZES, DEVICE_STATUS_ENUM, CODE_ENUM } from '@/common'
import {
  queryDeviceInstructSensor,
  queryDeviceInstructInfo,
  executeDeviceInstruct,
} from '@/api'
import moment from 'moment'
import { isEmpty } from 'lodash'
import InputParams from './input-params.vue'
import { ElMessage } from 'element-plus'
const MAX_TIME_OUT = 20

export default /*#__PURE__*/_defineComponent({
  __name: 'sub-device-command-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-change'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

watch(
  () => props.visible,
  () => {
    props.visible && queryDetail()
  }
)

const commandOps: any = ref([])
const commandCode = ref('')

const queryDetail = async () => {
  const { deviceId } = props.data
  const res: any = await queryDeviceInstructSensor({
    subDeviceId: deviceId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    console.log(res.data, '==')
    const { instructVOList, productInfoVO, ...p } = res.data
    commandOps.value = instructVOList || []

    const params = {
      ...productInfoVO,
      ...p,
    }

    infoList.value = infoList.value.map((item: any) => {
      return {
        ...item,
        value: item.formatter
          ? item.formatter(params)
          : params[item.prop] || '',
      }
    })
  }
}

const inputParamList = ref([])
const onCommadChange = () => {
  const result =
    commandOps.value.filter((_: any) => _.code === commandCode.value)[0]
      ?.inputParam || []
  inputParamList.value = result

  inputMap.value = result.reduce((mo: any, el: any) => {
    const defaultVal = el.dataType?.defaultVal
    mo[el.code] = isValid(defaultVal) ? defaultVal : undefined
    return mo
  }, {})
  responseList.value[0].value = ''
  responseList.value[1].value = ''
  clearInterval(timer.value)
}

const handleClose = () => {
  $emit('update:visible', false)
  responseList.value[0].value = ''
  responseList.value[1].value = ''
  commandCode.value = ''
  inputMap.value = {}
  inputParamList.value = []
  clearInterval(timer.value)
}

const col: any = [
  {
    prop: 'label',
    width: '150px',
    className: 'label-header',
  },
  {
    prop: 'value',
  },
]

const infoList = ref([
  {
    label: '子设备名称',
    prop: 'deviceName',
    value: '',
  },
  {
    label: '厂家',
    prop: 'producer',
    value: '',
  },
  {
    label: '品牌型号',
    prop: 'brand',
    value: '',
    formatter: ({ brand, productModel }: any) => {
      return [brand, productModel].filter(Boolean).join('/') || '-'
    },
  },
  {
    label: '端口号',
    prop: 'deviceSn',
    value: '',
  },
  {
    label: '子设备SN',
    prop: 'deviceSnAlias',
    value: '',
  },
  {
    label: '网关SN',
    prop: 'gatewaySn',
    value: '',
  },
])

const responseList = ref([
  {
    label: '当前响应',
    prop: 'response',
    value: '',
  },
  {
    label: '设备响应',
    prop: 'instructOutput',
    value: '',
  },
])

// 加上
const inputParamsData: any = computed(() => {
  return inputParamList.value.map((item: any) => {
    const defaultVal = item.dataType?.defaultVal
    const unit = item.dataType?.unit
    const code = item.code
    let text = ''
    if (unit) {
      text += `(${unit})`
    }
    text += `：${code}`
    return {
      otherProps: item.dataType,
      showInput: true,
      label: item.name + text,
      prop: item.code,
      // 默认值有效隐藏
      hidden: isValid(defaultVal),
    }
  }).filter((item:any)=>{
    return !item.hidden
  })
})

const tableData = computed(() => {
  return infoList.value.concat(inputParamsData.value.concat(responseList.value))
})

const inputMap: any = ref({})
const onInputValueChange = ({ code, value }: any) => {
  inputMap.value[code] = value
}

const isValid = (value: any) => {
  return !(value === null || value === undefined || value === '')
}

const validateInput = () => {
  console.log(inputMap.value, 'inputMap.value')
  return Object.keys(inputMap.value).some((key: string) => {
    const value = inputMap.value[key]
    return value === null || value === undefined || value === ''
  })
}

const tableLoading = ref(false)

const instructCommonad = async () => {
  if (validateInput()) {
    ElMessage({
      message: '请填写完指令参数',
      type: 'warning',
    })
    return
  }

  clearInterval(timer.value)

  responseList.value[0].value = '指令发送中...'
  const { deviceId } = props.data

  let params = {}
  if (!isEmpty(inputMap.value)) {
    params = {
      inputParam: inputMap.value,
    }
  }
  const res: any = await executeDeviceInstruct({
    subDeviceId: deviceId,
    instructCode: commandCode.value,
    ...params,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    responseList.value[0].value = '指令发送成功'
    console.log(res.data, 'command')
    queryResponse(res.data)

    let count = 0
    timer.value = setInterval(() => {
      responseList.value[0].value = `等待响应（${count}/${MAX_TIME_OUT}）`

      queryResponse(res.data)
      if (count++ >= MAX_TIME_OUT) {
        responseList.value[0].value = '已达到最大重试次数，设备未响应，请重试'
        clearInterval(timer.value)
      }
    }, 1000)
  } else {
    responseList.value[0].value = '指令发送失败'
  }
}

const timer: any = ref(1)

const queryResponse = async (id: any) => {
  const res: any = await queryDeviceInstructInfo({ id })
  if (res?.code === CODE_ENUM.SUCCESS) {
    if (res?.data?.instructOutput) {
      clearInterval(timer.value)
      responseList.value[0].value = '已收到响应'
      responseList.value[1].value = res?.data?.instructOutput
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: "命令下发",
    size: "480px",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_el_button, {
          onClick: instructCommonad,
          disabled: !commandCode.value,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("下发")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          onClick: handleClose,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_select, {
          modelValue: commandCode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((commandCode).value = $event)),
          onChange: onCommadChange,
          class: "select ws_ml5"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commandOps.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.code,
                label: item.name,
                value: item.code
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        class: "ws_mt24",
        border: true,
        "show-header": false
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item) => {
            return _createVNode(_component_el_table_column, _mergeProps({
              key: item.prop
            }, { ...item }, { "show-overflow-tooltip": "" }), {
              default: _withCtx((scope) => [
                (scope.row.showInput && item.prop !== 'label')
                  ? (_openBlock(), _createBlock(InputParams, {
                      onOnChange: onInputValueChange,
                      otherProps: scope.row.otherProps,
                      code: scope.row.prop,
                      key: scope.row.prop
                    }, null, 8, ["otherProps", "code"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row[item.prop]), 1))
              ]),
              _: 2
            }, 1040)
          }), 64))
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})